import React from "react";
import Modal from "react-bootstrap/Modal";
import Button from "react-bootstrap/Button";
import ViewApplicants from "./ViewApplicants";

function ViewApplicantsModal(props) {
  return (
    <div>
      <Modal
        size="xl"
        show={props.show}
        onHide={() => props.handleClose()}
        backdrop="static"
        keyboard={false}
      >
        <Modal.Header closeButton>
          <Modal.Title>View Applicants</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <ViewApplicants scholarshipId={props.selectedScholarship.id} />
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={props.handleClose}>
            Close
          </Button>
        </Modal.Footer>
      </Modal>
    </div>
  );
}

export default ViewApplicantsModal;
